import { render, staticRenderFns } from "./_base-query-search.vue?vue&type=template&id=32b22993"
import script from "./_base-query-search.vue?vue&type=script&lang=js"
export * from "./_base-query-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports